import { hasProperty, setProperty } from 'dot-prop';

export const sentrySanitizeUrl = (url: string | undefined) => {
  return String(url).replace(/https?:\/\//, '');
};

export const isValidObject = (
  val: unknown
): val is Record<number | string, unknown> => {
  return (
    val !== null &&
    typeof val === 'object' &&
    !Array.isArray(val) &&
    Object.keys(val).length > 0
  );
};

export const sanitizeEncodedJSONByDotNotation = (
  json: string,
  paths: string[],
  mask = 'XXXXX'
): string => {
  const result = JSON.parse(json);

  for (const path of paths) {
    try {
      if (hasProperty(result, path)) {
        setProperty(result, path, mask);
      }
    } catch (_) {
      continue;
    }
  }

  return JSON.stringify(result);
};
